import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import user from './user.store';
import { OnLoadStore } from './on-load.store';
import { DevsStore } from './devs.store';
import { DjinniStore } from './djinni.store';
import { ClientsStore } from './clients.store';
import { SalaryStore } from './salary.store';
import { JobsStore } from './jobs.store';

const store = new Vuex.Store({
  modules: {
    user,
    'on-load': OnLoadStore,
    'devs': DevsStore,
    'djinni': DjinniStore,
    'clients': ClientsStore,
    'salary': SalaryStore,
    'jobs': JobsStore,
  },
  state: {

  },
  mutations: {

  },
  actions: {

  }
});

export default store;
